var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.row.order)?_c('span',[_vm._v(_vm._s(_vm.row.order.total))]):(_vm.row.ccr_order)?_c('span',[_vm._v(_vm._s(_vm.row.ccr_order.total_amount))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fd4e0db","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/coupon_codes/common/OrderAmount.vue
// module id = null
// module chunks = 